module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEZSURBVEhL7ZNBSgNBEEUHs81lcgWXogbFO3gHcwDBhZeKggsDWbt16TqrSMf305+OzcyEat3mQVHTv/6vHoakOxEmpfS6C4L3xbE4zoZxLI5zYRyL49yf4bN9UY88TryyJtv+D5c8eWWN52EcK7D4nNpS39TM8gHnwjhWweJnzehvtDPLGQ1acKwCecryT83p95YzEltwrAeL7zSnf1jK7FMNONaD0URzLkiWMhJbcGwQW2qPtTDK8JK31JrauN/83qXngrUwWkYlH/foDHMfxy/A9EDTL2KRlXGOeb06g2FpXUylqefjUQa92ie9AlF/kN5bSbel0OItMLykhr7rhS0FtLC3AsM1taI2ZN7pVx71aPGeGKHrfgCHK0tge0VV6gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-truck/light/24.png
// module id = 2528
// module chunks = 2